import { colorBySource } from '@/@core/utils/filter'
import { logoAirlineUrl } from '@/@core/utils/utils'
import { URL_DEEP_LINK } from '@/constants/invoice'
import { env } from '@/libs/env'
import store from '@/store'

import entryDeclaration from './entryDeclaration'

const {
  isSplitEntryDeclaration,
  urlInvoicePortal,
  checkInVietnamAirlinesUrl,
  checkInCancellationVietnamAirlinesUrl,
  checkInBambooAirwaysUrl,
  checkInCancelBambooAirwayUrl,
  checkInVietjetAirUrl,
  checkInVietravelAirlinesUrl,
  instructionsForUseUrl,
} = env

export default [
  {
    title: 'Agency Balance',
    icon: 'DollarSignIcon',
    route: 'apps-flights-agencyBalance',
    visibleFloors: ['F1'],
    visibleRoles: ['KTT', 'ADM'],
  },
  {
    title: 'Flight v2',
    customIcon: 'flight',
    route: 'apps-flightsV2-page',
    action: 'booking.searchBooking',
  },
  {
    title: 'Reservations',
    customIcon: 'reservation',
    action: 'booking.listBooking',
    route: 'apps-reservations-list',
    openChildren: true,
    children: [
      {
        title: 'HOLD',
        route: 'apps-reservations_hold-list',
      },
      {
        title: 'PAID',
        route: 'apps-reservations_paid-list',
      },
      {
        title: 'CANCEL',
        route: 'apps-reservations_cancel-list',
      },
      // {
      //   title: 'EXPIRED',
      //   route: 'apps-reservations_expired-list',
      // },
      {
        title: 'reservation.viewEticket',
        route: 'apps-findEticket',
      },
      {
        title: 'reservation.findBookingVJ.title',
        route: 'apps-findBookingVJ',
        visibleFloors: ['F1'],
      },
      {
        title: 'reservation.bookingStatistic.title',
        route: 'apps-bookings-statistic',
        visibleFloors: ['F1'],
        visibleRoles: ['OPE', 'ADM', 'KTT'],
      },
      {
        title: 'reservation.pastDayBooking.title',
        route: 'apps-past-day-booking-list',
        // visibleFloors: ['F1', 'F2'],
      },
    ],
  },
  {
    title: 'reservation.findBookingByPnrCode',
    route: 'apps-findByPnrCode',
    icon: 'SearchIcon',
    openChildren: true,
    children: [
      {
        title: 'Vietnam Airlines',
        route: { name: 'apps-findByPnrCode_VN1A' },
        image: logoAirlineUrl('VN'),
        color: colorBySource('VN1A'),
        target: '_blank',
      },
      {
        title: 'Vietnam Airlines MT',
        route: { name: 'apps-findByPnrCode_VN1A_MT' },
        image: logoAirlineUrl('VN'),
        color: colorBySource('VN1A_MT'),
        target: '_blank',
        hideAll: env.removeSourcesInFindPnrOutSystem.includes('VN1A_MT'),
      },
      {
        title: 'Vietjet Air',
        route: { name: 'apps-findByPnrCode_VJ' },
        image: logoAirlineUrl('VJ'),
        color: colorBySource('VJ'),
        target: '_blank',
      },
      {
        title: 'Bamboo Airways',
        route: { name: 'apps-findByPnrCode_QH' },
        image: logoAirlineUrl('QH'),
        color: colorBySource('QH'),
        target: '_blank',
      },
      {
        title: 'Vietravel Airlines',
        route: { name: 'apps-findByPnrCode_VU' },
        image: logoAirlineUrl('VU'),
        color: colorBySource('VU'),
        target: '_blank',
      },
      {
        title: '1G Travelport',
        route: { name: 'apps-findByPnrCode_1G' },
        image: logoAirlineUrl('1G'),
        color: colorBySource('1G'),
        target: '_blank',
      },
      {
        title: 'Khác (OF, TR)',
        route: { name: 'apps-findByPnrCode_Other' },
        target: '_blank',
      },
    ],
  },
  {
    title: 'Retail',
    icon: 'ShoppingCartIcon',
    visibleFloors: ['F2'],
    visibleRoles: ['OPE', 'ADM'],
    children: [
      {
        title: 'Retail Report',
        route: 'apps-retailGeneral',
      },
      {
        title: 'Retail Bookings',
        route: 'apps-retailBookings',
      },
      {
        title: 'Account Payable Retail',
        route: 'apps-retailAccountsPayable-list',
      },
      {
        title: 'Sale Report Retail',
        route: 'apps-retailSaleReports',
      },
      {
        title: 'Retail Config Service Fee',
        route: 'apps-retailConfigsServiceFee',
      },
    ],
  },
  {
    title: 'Check-in online',
    children: [
      {
        title: 'Vietjet Air',
        href: checkInVietjetAirUrl,
        image: logoAirlineUrl('VJ'),
      },
      {
        title: 'Check-in Bamboo',
        href: checkInBambooAirwaysUrl,
        image: logoAirlineUrl('QH'),
      },
      {
        title: 'Check-in cancellation Bamboo',
        href: checkInCancelBambooAirwayUrl,
        image: logoAirlineUrl('QH'),
      },
      {
        title: 'Vietravel Airlines',
        href: checkInVietravelAirlinesUrl,
        image: logoAirlineUrl('VU'),
      },
      {
        title: 'Check-in VNA',
        href: checkInVietnamAirlinesUrl,
        image: logoAirlineUrl('VN'),
      },
      {
        title: 'Check-in cancellation VNA',
        href: checkInCancellationVietnamAirlinesUrl,
        image: logoAirlineUrl('VN'),
      },
      ...(isSplitEntryDeclaration ? [] : entryDeclaration),
    ],
  },
  {
    title: 'Flights Schedule',
    customIcon: 'flightsSchedule',
    route: 'apps-flightsSchedule',
    hideAll: env.isHideFlightsSchedule,
  },
  {
    title: 'flightCalendar',
    customIcon: 'calendar',
    route: 'apps-calendar-flight',
    hideAll: env.isHideFlightCalendar,
  },
  {
    title: 'Flight Preparation',
    icon: 'FileIcon',
    route: 'apps-flight-preparation-page',
  },
  {
    title: 'Entry declaration',
    children: entryDeclaration,
    customIcon: 'checkSquare',
    hideAll: !isSplitEntryDeclaration,
  },
  // {
  //   title: 'reservation.lowFareTracking.title',
  //   icon: 'MonitorIcon',
  //   route: 'apps-low-fare-tracking-statistic',
  //   visibleFloors: ['F1', 'F2'],
  //   // hideForProduction: true,
  // },
  {
    title: 'Train',
    customIcon: 'trainIcon',
    // hideForProduction: true,
    hideAll: env.isHideTrain,
    isShowFunction: () => store.getters['userStore/getAgencyEnableTrain'],
    children: [
      {
        title: 'Train Search',
        icon: 'SearchIcon',
        route: 'apps-trainSearch',
      },
      {
        title: 'Train Ticket List',
        icon: 'ListIcon',
        route: 'apps-train-ticketList',
      },
      {
        title: 'Train Ticket Search',
        icon: 'SearchIcon',
        route: 'apps-trainTicketSearch',
      },
    ],
  },
  {
    title: 'Tour List',
    customIcon: 'tour',
    route: 'apps-toursList',
    isShowFunction: () => store.getters['userStore/getAgencyEnableTour'],
    children: [
      {
        title: 'Tour List',
        customIcon: 'tour',
        route: 'apps-toursList',
      },
      {
        title: 'Tour Booking List',
        icon: 'ListIcon',
        route: 'apps-toursBooking-list',
      },
    ],
    hideAll: env.isHideTour,
    visibleFloors: ['F1', 'F2'],
  },
  {
    title: 'Terminals',
    icon: 'TerminalIcon',
    route: 'apps-terminals',
    visibleFloors: ['F1'],
    visibleRoles: ['ADM', 'OPE', 'BE'],
    hideAll: env.isHideTerminal,
  },
  {
    title: 'Package configs',
    icon: 'PackageIcon',
    visibleFloors: ['F1', 'F2'],
    visibleRoles: ['ADM', 'OPE'],
    // hideForProduction: true,
    children: [
      {
        title: 'Package configs',
        route: 'apps-packageConfigs-list',
      },
      {
        title: 'Agency package configs',
        route: 'apps-agencyPackageConfigs-list',
      },
      {
        title: 'Agency package history',
        route: 'apps-agencyPackageHistory-list',
      },
      {
        title: 'Agency package order',
        route: 'apps-agencyPackageOrder-list',
      },
      {
        title: 'Package Coupons',
        route: 'apps-packageCoupon-list',

        visibleFloors: ['F1'],
      },
    ],
  },
  // {
  //   title: 'Documentations',
  //   icon: 'FileIcon',
  //   // action: '',
  //   children: [
  //     {
  //       title: 'Airlines 1G can pay',
  //       route: 'apps-airlines1gCanPay',
  //     },
  //   ],
  // },
  {
    title: 'Documentations',
    icon: 'FolderIcon',
    children: [
      {
        title: 'officialDispatch',
        route: 'apps-documents-folder-view',
        // visibleFloors: ['F1', 'F2'],
      },
      {
        title: 'Airlines 1G can pay',
        route: 'apps-airlines1gCanPay',
        visibleFloors: ['F1', 'F2'],
      },
    ],
  },
  {
    title: 'Instructions for use',
    customIcon: 'help',
    href: instructionsForUseUrl,
    hideAll: !instructionsForUseUrl,
  },
  {
    title: 'Work Schedule',
    customIcon: 'schedule',
    children: [
      {
        title: 'schedule.agencyWorkSchedule',
        route: 'apps-parent-workSchedules-page',
        visibleFloors: ['F2', 'F3'],
      },
      {
        title: 'schedule.workSchedule',
        route: 'apps-workSchedules-page',
        visibleFloors: ['F1', 'F2'],
      },
    ],
  },
  {
    title: 'Customer',
    icon: 'UserIcon',
    route: 'apps-customers-list',
    action: 'customer.listCustomer',
  },
  {
    title: 'Message Board',
    customIcon: 'speaker',
    route: 'apps-messageBoard',
    hideAll: env.isHideMessageBoard,
  },
  // {
  //   title: 'Customer2',
  //   icon: 'UserIcon',
  //   route: 'apps-customers-list2',
  //   action: 'customer.listCustomer',
  //   hideForProduction: true,
  // },
  {
    title: 'Employee',
    icon: 'UsersIcon',
    route: 'apps-employees-list',
    action: 'employee.listEmployee',
  },
  {
    title: 'Agency',
    icon: 'ArchiveIcon',
    route: 'apps-agencies-list',
    visibleFloors: ['F1', 'F2'],
  },

  // {
  //   title: 'Registers',
  //   icon: 'ArchiveIcon',
  //   route: 'apps-reg-list',
  // },
  {
    title: 'titleRepicient',
    icon: 'DownloadIcon',
    route: 'apps-topupRecipient-list',
    action: 'topup.listTopup',
    children: [
      {
        title: 'pendingPayment',
        route: 'apps-topupRecipient_pending-list',
      },
      {
        title: 'done',
        route: 'apps-topupRecipient_done-list',
      },
    ],
    visibleFloors: ['F1', 'F2'],
  },
  {
    title: 'titleSender',
    icon: 'UploadIcon',
    route: 'apps-topupSender-list',
    action: 'topup.listTopup',
    children: [
      {
        title: 'pendingPayment',
        route: 'apps-topupSender_pending-list',
      },
      {
        title: 'done',
        route: 'apps-topupSender_done-list',
      },
    ],
    visibleFloors: ['F3', 'F2'],
  },
  {
    title: 'Invoice',
    icon: 'FileTextIcon',
    action: 'invoice.listInvoice',
    route: 'apps-invoiceList',
    visibleFloors: ['F1', 'F2'],
    visibleRoles: ['ADM', 'KTT', 'KTV'],
    hideAll: env.isHideInvoice,
    isShowFunction: () => store.getters['userStore/getAgencyEnableInvoice'],
    children: [
      {
        title: 'Invoice List',
        icon: 'FileTextIcon',
        route: 'apps-invoiceList',
      },
      {
        title: 'Incorrect Invoices List',
        customIcon: 'invoice',
        route: 'apps-incorrectInvoices-list',
        hideForProduction: true,
      },
      {
        title: 'Invoice Create',
        icon: 'FilePlusIcon',
        route: 'apps-invoiceCreate',
      },
      {
        title: 'Release Registration',
        icon: 'ApertureIcon',
        children: [
          {
            title: 'Declaration',
            href: `${urlInvoicePortal}${URL_DEEP_LINK.DECLARATION}`,
          },
          {
            title: 'Authorization Declaration',
            href: `${urlInvoicePortal}${URL_DEEP_LINK.AUTHORIZATION_DECLARATION}`,
          },
          {
            title: 'Invoice Template',
            href: `${urlInvoicePortal}${URL_DEEP_LINK.INVOICE_TEMPLATE_MANAGE}`,
          },
        ],
      },
      {
        title: 'Certificate Manage',
        icon: 'EditIcon',
        href: `${urlInvoicePortal}${URL_DEEP_LINK.CERTIFICATE_MANAGE}`,
      },
      {
        title: 'Invoices Release Batches',
        customIcon: 'splitPassenger',
        href: `${urlInvoicePortal}${URL_DEEP_LINK.INVOICE_RELEASE_BATCHES}`,
      },
      // vé ngoài hệ thống
      {
        title: 'Invoice Tickets',
        icon: 'FileTextIcon',
        route: 'apps-invoiceTicketList',
        children: [
          {
            title: 'Invoice Ticket List',
            customIcon: 'menuOutline',
            route: 'apps-invoiceTicketList',
          },
          {
            title: 'Invoice Ticket Create',
            customIcon: 'plusOutline',
            route: 'apps-invoiceTicketCreate',
          },
        ],
      },
    ],
  },
  {
    title: 'Invoice Request List',
    customIcon: 'invoice',
    action: 'invoice.listInvoice',
    route: 'apps-invoiceRequest-list',
    visibleFloors: ['F1', 'F2'],
    visibleRoles: ['ADM', 'KTT', 'KTV'],
    hideAll: env.isHideInvoice,
    isShowFunction: () => store.getters['userStore/getAgencyEnableInvoiceRequest'],
  },
  {
    title: 'Accounts payable',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'Accounts payable general',
        // icon: 'DollarSignIcon',
        route: 'apps-accountsPayable-list',
        action: 'acc_payable.readAccpayble',
      },
      {
        title: 'Sale Report',
        // icon: 'ShoppingBagIcon',
        route: 'apps-saleReport',
        action: 'sales_report.readSalereport',
      },

      {
        title: 'Sale Report Refund Ticket',
        // icon: 'ShoppingBagIcon',
        route: 'apps-saleReportRefundTicket',
        action: 'sales_report.readSalereport',
      },
      {
        title: 'overPercentage',
        route: 'apps-agencies_warning_over_percentage-list',
        visibleRoles: ['KTT', 'KTV'],
      },
    ],
  },
  {
    title: 'Resell Ticket',
    icon: 'ShoppingCartIcon',
    visibleFloors: ['F1', 'F2'],
    // hideForProduction: env.isHideResell,s
    hideAll: env.isHideResell,
    children: [
      {
        title: 'Search resell Ticket',
        icon: 'SearchIcon',
        route: 'apps-resell-ticket',
      },
      {
        title: 'Manager Resell Ticket',
        icon: 'SlidersIcon',
        route: 'apps-manager-resell-ticket',
      },
    ],
  },
  {
    title: 'Promotion',
    icon: 'PercentIcon',
    // action: 'promotionAg.listPromotion',
    visibleFloors: ['F1', 'F2'],
    children: [
      {
        title: 'Promotion AG',
        route: 'apps-promotionAg-list',
      },
      {
        title: 'Promotion Airline',
        route: 'apps-promotionAirline-list',
        visibleFloors: ['F1'],
      },
      {
        title: 'Promotion User',
        route: 'apps-promotionUser-list',
        visibleFloors: ['F1'],
        visibleRoles: ['OPE', 'ADM'],
      },
    ],
  },
  {
    title: 'Utils',
    icon: 'ToolIcon',
    route: 'apps-utilsTravelport',
  },
  // {
  //   title: 'Role',
  //   icon: 'KeyIcon',
  //   route: 'apps-role-list',
  //   action: 'authz.getCustomRole',
  //   visibleFloors: ['F1', 'F2'],
  // },
  {
    title: 'auditLog.title',
    icon: 'ClockIcon',
    route: 'apps-audit-log-list',
    // action: 'audit_log.readAuditlog',
    visibleFloors: ['F1'],
    visibleRoles: ['OPE', 'ADM'],
  },
  {
    title: 'Agent Request Stats',
    customIcon: 'stats',
    route: 'apps-agent-request-stats',
    visibleFloors: ['F1'],
    visibleRoles: ['ADM'],
  },
  {
    title: 'Settings',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'My account',
        route: 'account-settings',
      },
      {
        title: 'Agency account',
        route: 'apps-agencySetting',
        visibleRoles: ['ADM', 'OPE'],
      },
      {
        title: 'Fee Configs',
        route: 'apps-configsFee',
        visibleFloors: ['F1', 'F2'],
      },
      {
        title: 'Service Fee Configs',
        route: 'apps-configsServiceFee',
      },
      {
        title: 'electronicTicket',
        route: 'apps-configsTicket',
      },
      {
        title: 'electronicTicketTrain',
        route: 'apps-configsTicketTrain',
        hideAll: env.isHideTrain,
        isShowFunction: () => store.getters['userStore/getAgencyEnableTrain'],
      },
      {
        title: 'configsDisplay',
        route: 'apps-configsDisplay',
      },
      {
        title: 'systemConfigs',
        route: 'apps-systemConfigs',
        hideAll: !env.isDevelopment,
        visibleFloors: ['F1'],
        visibleRoles: ['ADM'],
      },
    ],
  },
  {
    title: 'Send Notification',
    route: 'apps-configsNotification',
    icon: 'BellIcon',
    visibleFloors: ['F1'],
    visibleRoles: ['ADM', 'OPE'],
    // hideForProduction: true,
  },
  {
    title: 'sepayManager',
    icon: 'DollarSignIcon',
    visibleFloors: ['F1'],
    visibleRoles: ['KTT', 'KTV', 'ADM'],
    hideForProduction: true,
    hideAll: true,
    children: [
      {
        title: 'Transactions',
        icon: 'FileTextIcon',
        hideForProduction: true,
        route: 'apps-transaction',
      },
      {
        title: 'Bank accounts',
        icon: 'FileTextIcon',
        hideForProduction: true,
        route: 'apps-bank-account',
      },
      {
        title: 'Companies',
        icon: 'FileTextIcon',
        route: 'apps-company',
        hideForProduction: true,
      },
      {
        title: 'Banks',
        icon: 'HomeIcon',
        route: 'apps-banks',
        hideForProduction: true,
      },
    ],
  },
  {
    title: 'Support Request',
    icon: 'ActivityIcon',
    visibleFloors: ['F1', 'F2'],
    route: 'apps-supports',
    hideForProduction: env.isHideSupportRequest,
    hideAll: env.isHideSupportRequest,
  },
]
